import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { Stack as a, Typography as c, IconButton as p } from "@mui/material";
import m from "./CloseRounded.mjs";
const f = (e) => {
  const {
    children: r,
    isCloseIconButtonHidden: i,
    onClose: n,
    sx: d = {},
    ...l
  } = e;
  return /* @__PURE__ */ s(
    a,
    {
      direction: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 2,
      padding: 3,
      sx: {
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
        borderBottomColor: (o) => o.palette.divider,
        ...d || {}
      },
      ...l,
      children: [
        /* @__PURE__ */ t(
          c,
          {
            variant: "DisplayMd.Bold",
            color: (o) => o.palette.text.primary,
            children: r
          }
        ),
        !i && /* @__PURE__ */ t(p, { onClick: n, children: /* @__PURE__ */ t(m, {}) })
      ]
    }
  );
};
export {
  f as DrawerHeader
};
//# sourceMappingURL=index32.mjs.map
